import React from 'react'
import { connect } from 'react-redux'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { Button, Divider } from 'antd'
import './ListClientsStyle.css'
import { getUser } from '../../../reducers'
import { useState } from 'react';
import { message } from 'antd';
import { db } from '../../../config/Fire';
import * as Constants from '../../../constants'
import ClientsTable from '../../containers/ClientsTable';

function compareByBumeration (a, b) {
    if (a.numeration < b.numeration) {
        return -1;
    } else if (a.numeration > b.numeration) {
        return 1;
    } else {
        return 0;
    }
}

const ListClients = props => {
    const { clients, user } = props
    const [loadingClients, setLoadingClients] = useState(false)

	const exportClientsToExcel = async () => {
		try {
			message.loading({ content: 'Generando Excel...', key: 'excel_clients' })
			
			const usersSnap = await db.ref('users').once('value')
			if (!usersSnap.exists()) {
				message.error({ content: 'No se encontraron usuarios', key: 'excel_clients' })
				return
			}
			
			const clientsByYear = {}
			
			usersSnap.forEach(userSnap => {
				const clientObj = userSnap.val()
				if (clientObj && clientObj.userType === 'CLIENT') {
					let year = 'Sin año'
					if (clientObj.createDate) {
						const parts = clientObj.createDate.split(' ')
						const dateParts = parts[0].split('/')
						if (dateParts.length === 3) {
							year = dateParts[2]
						}
					}
					
					if (!clientsByYear[year]) {
						clientsByYear[year] = []
					}
					clientsByYear[year].push(clientObj)
				}
			})
			
			const years = Object.keys(clientsByYear).sort((a, b) => b.localeCompare(a))
			
			const workbook = new ExcelJS.Workbook()
			const worksheet = workbook.addWorksheet('Clientes')
			
			const yearFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF46B0B0' } }
			const yearFont = { bold: true, size: 14 }
			
			worksheet.columns = [
				{ width: 35 }, 
				{ width: 40 }, 
				{ width: 20 }, 
				{ width: 25 }, 
			]
			
			const headerFont = { bold: true, color: { argb: 'FFFFFFFF' } }
			const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF263238' } }
			
			years.forEach((year) => {
				const rowYear = worksheet.addRow([year, '', '', ''])
				worksheet.mergeCells(`A${rowYear.number}:D${rowYear.number}`)
				const cell = worksheet.getCell(`A${rowYear.number}`)
				cell.fill = yearFill
				cell.font = yearFont
				cell.alignment = { horizontal: 'center', vertical: 'middle' }
				
				const rowCols = worksheet.addRow(['Nombre', 'Email', 'Teléfono', 'Fecha de Creación'])
				rowCols.eachCell(c => {
					c.fill = headerFill
					c.font = headerFont
					c.alignment = { horizontal: 'center' }
				})
				
				const clientsForYear = clientsByYear[year]
				clientsForYear.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
				
				clientsForYear.forEach(client => {
					worksheet.addRow([
						client.name || '--',
						(client.email && String(client.email) !== '0' && String(client.email) !== '1' && String(client.email) !== '-') ? client.email : '--',
						(client.phone && String(client.phone) !== '0' && String(client.phone) !== '1' && String(client.phone) !== '-') ? client.phone : '--',
						client.createDate || '--'
					])
				})
				
				worksheet.addRow([])
				worksheet.addRow([])
			})
			
			const buffer = await workbook.xlsx.writeBuffer()
			const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			saveAs(blob, `Clientes.xlsx`)
			message.success({ content: 'Excel descargado exitosamente', key: 'excel_clients' })
			
		} catch (error) {
			console.error("Error generando Excel de clientes:", error)
			message.error({ content: 'Error al generar el Excel', key: 'excel_clients' })
		}
	}

    const showClients = id => {
        props.onShowClient(id)
    }

    const removeClient = record => {
        if (record) {
            try {
                setLoadingClients(true)
                db.ref(Constants.MAIN_NODES.USERS + '/' + record.id).remove()
                message.success('El cliente se eliminó exitósamente')
                setLoadingClients(false)
                props.onClientDeleted(record.id)
            } catch (err) {
                console.log(err)
                message.error('Se produjo un error al eliminar el cliente. Por favor, vuelva a intentarlo')
                setLoadingClients(false)
            }
        }
    }

    return (
        <Grid className="listOutsourcingCont">
            <Row center="xs">
                <Col xs={12}>
                    <h2>Clientes</h2>
                </Col>
            </Row>
            <Divider/>
            <Button className="newBidOrderButton" onClick={props.onNewSelected} type="primary" size="large">Nuevo Cliente</Button> 
			{user && (user.email === 'melinabodini@sdingenieria.com.ar' || user.email === 'pruebas@autosolve.com') && (
				<Button 
					className="exportClientsToExcelButton" 
					onClick={exportClientsToExcel} 
					type="default" 
					size="large"
					style={{ marginLeft: 15 }}
				>
					Descargar excel de clientes
				</Button>
			)}
            <Row center="xs">
                <Col xs={12}>
                    <ClientsTable data={(clients && clients !== null) ? Object.values(clients).sort(compareByBumeration) : []}
                        onShowClients={showClients}
                        onRemoveClient={removeClient} loading={loadingClients}
                    />
                </Col>
            </Row>
        </Grid>
    )
}

ListClients.propTypes = {
}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default connect(mapStateToProps, mapDispatchToPropsActions)(ListClients);